import { ROADMAP_STATUS } from './'

export const RoadMapData = [
  {
    name: 'NFKey sale',
    status: ROADMAP_STATUS.DONE,
    date: 'Done',
    desc: 'Premium animated KEY NFTs, that will let holders claim a free RaceCar NFT before the Public Sale. NFKeys grant holders with a beautiful rare asset, that will also provide advantages in and out of the game. Earn 3% reflection on secondary sales.'
  },
  {
    name: 'Lineup Reveal',
    status: ROADMAP_STATUS.DONE,
    date: 'Done',
    desc: 'The team will reveal 10 models a day and will let the community vote for their favorite to showcase the selected models in a weekly video!'
  },
  {
    name: 'Verified collection',
    status: ROADMAP_STATUS.DONE,
    date: 'Done',
    desc: 'We are already working to make our RaceCar NFTs collection verified on both NFTrade and KALAO.'
  },
  {
    name: 'RaceCar NFT Public Sale',
    status: ROADMAP_STATUS.RUNNING,
    date: 'In Progress',
    desc: "10000 Premium handmade 3D unique RaceCar NFTs that will allow you to play our game when released. Different levels of discount will be applied depending on the amount of $RaceX in your Wallet! Announcement to come! NFKey holders have been allocated their free RaceCar per NFKey. 3% reflection on sale will be shared amongst the NFT holders."
  },
  {
    name: 'Multiplayer Race Alpha Demo',
    status: ROADMAP_STATUS.DONE,
    date: 'Done',
    desc: 'Release of Virtual Racing App V1a.'
  },
  {
    name: 'Multiplayer Race Beta Demo',
    status: ROADMAP_STATUS.DONE,
    date: 'Done',
    desc: 'Release of Virtual Racing App V1b. With Web3 integration to show NFCars'
  },
  {
    name: 'Multiplayer Race V1.0',
    status: ROADMAP_STATUS.RUNNING,
    date: 'Q4 2025 / Change in Market',
    desc: 'Release of Virtual Racing App V1. with integrated Web3 using NFT to race'
  },
  {
    name: 'NFT Staking',
    status: ROADMAP_STATUS.RUNNING,
    date: 'Q4 2025',
    desc: 'Stake your NFT for training, services, and upgrades.'
  },
  {
    name: 'Real World Racing',
    status: ROADMAP_STATUS.WORKING,
    date: 'Q1/Q2 2026',
    desc: 'Watch real-world races on Virtual Sim. Real world race results fed into Race Sim to produce viewable races.'
  },
  {
    name: 'Real vs Virtual',
    status: ROADMAP_STATUS.WORKING,
    date: 'Q2 2026',
    desc: 'Combine the ability to add real world race results into virtual championships and vice versa.'
  },
  {
    name: 'The Future and Beyond',
    status: ROADMAP_STATUS.WORKING,
    date: 'Q2 2026',
    desc: 'Creation of RACEX DAO. RACEX DAO members will be able to vote for enhancements to the platform.'
  }
]